import { Loading } from "components"

export function SummaryCard(params: {
  label?: string
  sideLabel?: string
  value?: string | number
  loading?: boolean
}): JSX.Element {
  return (
    <div className="flex min-h-[120px]">

      {params.sideLabel && (
        <div className="bg-black w-8 flex items-center justify-center">
          <div className="text-white -rotate-90 whitespace-nowrap text-sm uppercase font-bold text-center">{params.sideLabel}</div>
        </div>
      )}

      <section className={`grow font-bold flex flex-col justify-center gap-1 p-3 ${!params.sideLabel && "text-center"}`}>
        <div className="text-sm">{params.label}</div>
        {params.value && <div className="text-lg font-bold">
          
          {params.loading ? <Loading loading /> : params.value}
          </div>}
      </section>
    </div>
  )
}